import React from 'react';
import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';

import { useCCTableContext } from '../cc-table.context';
import { HeadFilterButton } from './head-filter-button';

export const CCTableHead = () => {
  const { columns, order, orderBy, updateTableStatus } = useCCTableContext();

  const onRequestSort = (property: string) => {
    const isAsc = orderBy === property && order === 'asc';

    updateTableStatus({ order: isAsc ? 'desc' : 'asc', orderBy: property });
  };

  return (
    <TableHead>
      <TableRow>
        {
          // eslint-disable-next-line
          columns.map(({ id, label, sorter = true, filter = true, render, mobileSx, ...rest }, index) => {
            return (
              <TableCell key={`head-cell-${index}`} {...rest}>
                <TableSortLabel
                  active={orderBy === id}
                  direction={orderBy === id ? order : 'asc'}
                  onClick={() => onRequestSort(id)}
                  disabled={!sorter}
                >
                  {label}
                </TableSortLabel>

                {filter !== false && <HeadFilterButton filter={filter} columnId={id} />}
              </TableCell>
            );
          })
        }
      </TableRow>
    </TableHead>
  );
};
